module.exports = __webpack_public_path__ + "static/media/tartine.96c2f754.jpg";